module.exports = __webpack_public_path__ + "img/glados autograph - peter.8972c596.jpg";